import Breadcrumbs from '@/atoms/Breadcrumb'
import ProductsGrid from '@/organisms/ProductsGrid/ProductsGrid'
import Group from '@/ts/Group'
import Presentation from '@/views/common/Presentation'

import GroupPageHero from './includes/GroupPageHero'
import useGroupProducts from './logic/useGroupProducts'

function GroupView({ group }: GroupViewProps) {
  const { filters, maxPrice, total, products } = useGroupProducts()

  if (!filters || !products) return <></>

  return (
    <div>
      <Breadcrumbs crumbs={[{ label: `${group.name}` }]} className="mb-8" />
      <div className="space-y-10 md:space-y-20">
        <GroupPageHero
          title={group?.name}
          description={group?.description}
          bannerSource={group?.banner_path}
        />
        <Presentation
          title="all_products"
          totalItems={total}
          noResults={total === 0}
          filters={filters as any}
          maxPrice={maxPrice}
          shouldDisplayContent={total > 0}
        >
          <ProductsGrid products={products} asFeatured />
        </Presentation>
      </div>
    </div>
  )
}

interface GroupViewProps {
  group: Group
}

export default GroupView
